module.exports = __webpack_public_path__ + "static/lframe-apply-704694809e4133212f5bd5215f38c784.png";